import { useMemo } from 'react';
import {
  buildGuaranteesApplicationPath,
  buildGuaranteesApplicationStep2Path,
  buildGuaranteesApplicationStep3Path,
} from '~/modules/guarantees/utils.ts';
import GuaranteesStepNavigator from '../../stepNavigation/GuaranteesStepNavigator.tsx';
import { guaranteesClientStepNavigationConfig } from './constants.ts';
import { TClientStepNavigatorProps } from '~/modules/guarantees/form/application/client/stepNavigation/types.ts';


const ClientStepNavigator = ({
  applicationId,
  contragentId,
  currentStepKey,
  disabledStepKeys = [],
  containerStyles,
  stepperStyles,
}: TClientStepNavigatorProps) => {
  const stepConfig = useMemo(
    () =>
      guaranteesClientStepNavigationConfig.map((item) => ({
        ...item,
        disabled: disabledStepKeys.includes(item.key),
      })),
    [disabledStepKeys]
  );
  const pathByKey = useMemo(
    () => ({
      step1: buildGuaranteesApplicationPath(applicationId, contragentId, false),
      step2: buildGuaranteesApplicationStep2Path(applicationId, contragentId, false),
      step3: buildGuaranteesApplicationStep3Path(applicationId, contragentId, false),
    }),
    [applicationId, contragentId]
  );
  const navigateStateByKey = useMemo(
    () => ({
      step1: {
        fromGuaranteesClientStepNavigator: true,
      },
    }),
    []
  );

  return (
    <GuaranteesStepNavigator
      containerId="guaranteesClientStepsContainer"
      currentStepKey={currentStepKey}
      items={stepConfig}
      pathByKey={pathByKey}
      navigateStateByKey={navigateStateByKey}
      containerStyles={containerStyles}
      stepperStyles={stepperStyles}
    />
  );
};

export default ClientStepNavigator;
